export default "__VITE_ASSET__f55d3819__"